function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { observer } from "mobx-react";
import { isJsonObject } from "../../../Core/Json";
import TerriaError from "../../../Core/TerriaError";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import DiscretelyTimeVaryingMixin from "../../../ModelMixins/DiscretelyTimeVaryingMixin";
import hasTraits from "../../../Models/Definition/hasTraits";
import { DEFAULT_PLACEMENT } from "../../../Models/SelectableDimensions/SelectableDimensions";
import WebMapServiceCatalogItemTraits from "../../../Traits/TraitsClasses/WebMapServiceCatalogItemTraits";
import ChartItemSelector from "./ChartItemSelector";
import ColorScaleRangeSection from "./ColorScaleRangeSection";
import DateTimeSelectorSection from "./DateTimeSelectorSection";
import FilterSection from "./FilterSection";
import GeneratedControlSection from "./GeneratedControlSection";
import LeftRightSection from "./LeftRightSection";
import Legend from "./Legend";
import OpacitySection from "./OpacitySection";
import SatelliteImageryTimeFilterSection from "./SatelliteImageryTimeFilterSection";
import { ScaleWorkbenchInfo } from "./ScaleWorkbenchInfo";
import DimensionSelectorSection from "./SelectableDimensionSection";
import ShortReport from "./ShortReport";
import TimerSection from "./TimerSection";
import ViewingControls from "./ViewingControls";
import { disableAllControls, enableAllControls } from "./WorkbenchControls";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const WorkbenchItemControls = observer(_ref => {
  var _propsControls$disabl;
  let {
    item,
    viewState,
    controls: propsControls = {},
    disableViewingControlsMenu
  } = _ref;
  const itemControls = CatalogMemberMixin.isMixedInto(item) && isJsonObject(item.workbenchControlFlags) ? item.workbenchControlFlags : undefined;

  // disable/enable all controls, props controls overrides item controls
  const disableAll = !!((_propsControls$disabl = propsControls.disableAll) !== null && _propsControls$disabl !== void 0 ? _propsControls$disabl : itemControls === null || itemControls === void 0 ? void 0 : itemControls.disableAll);
  const controls = disableAll ? _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, disableAllControls), itemControls), propsControls), {}, {
    disableAll
  }) : _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, enableAllControls), itemControls), propsControls), {}, {
    disableAll
  });
  const {
    generatedControls,
    error
  } = generateControls(viewState, item);
  if (error) {
    error.log();
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [disableViewingControlsMenu ? null : /*#__PURE__*/_jsx(ViewingControls, {
      item: item,
      viewState: viewState,
      controls: controls
    }), controls.opacity ? /*#__PURE__*/_jsx(OpacitySection, {
      item: item
    }) : null, controls.scaleWorkbench ? /*#__PURE__*/_jsx(ScaleWorkbenchInfo, {
      item: item
    }) : null, controls.timer ? /*#__PURE__*/_jsx(TimerSection, {
      item: item
    }) : null, controls.compare ? /*#__PURE__*/_jsx(LeftRightSection, {
      item: item
    }) : null, controls.chartItems ? /*#__PURE__*/_jsx(ChartItemSelector, {
      item: item
    }) : null, controls.filter ? /*#__PURE__*/_jsx(FilterSection, {
      item: item
    }) : null, controls.dateTime && DiscretelyTimeVaryingMixin.isMixedInto(item) ? /*#__PURE__*/_jsx(DateTimeSelectorSection, {
      item: item
    }) : null, controls.timeFilter ? /*#__PURE__*/_jsx(SatelliteImageryTimeFilterSection, {
      item: item
    }) : null, controls.selectableDimensions ? /*#__PURE__*/_jsx(DimensionSelectorSection, {
      item: item,
      placement: DEFAULT_PLACEMENT
    }) : null, /*#__PURE__*/_jsx(GeneratedControlSection, {
      item: item,
      placement: DEFAULT_PLACEMENT,
      controls: generatedControls
    }), controls.colorScaleRange && hasTraits(item, WebMapServiceCatalogItemTraits, "colorScaleMinimum") && hasTraits(item, WebMapServiceCatalogItemTraits, "colorScaleMaximum") && /*#__PURE__*/_jsx(ColorScaleRangeSection, {
      item: item,
      minValue: item.colorScaleMinimum,
      maxValue: item.colorScaleMaximum
    }), controls.shortReport ? /*#__PURE__*/_jsx(ShortReport, {
      item: item
    }) : null, controls.legend ? /*#__PURE__*/_jsx(Legend, {
      item: item
    }) : null, controls.selectableDimensions ? /*#__PURE__*/_jsx(DimensionSelectorSection, {
      item: item,
      placement: "belowLegend"
    }) : null, /*#__PURE__*/_jsx(GeneratedControlSection, {
      item: item,
      placement: "belowLegend",
      controls: generatedControls
    })]
  });
});
function generateControls(viewState, item) {
  const generatedControls = [];
  const errors = [];
  viewState.workbenchItemInputGenerators.forEach(generator => {
    try {
      const control = generator(item);
      if (control) {
        generatedControls.push(control);
      }
    } catch (error) {
      errors.push(TerriaError.from(error));
    }
  });
  const error = errors.length > 0 ? TerriaError.combine(errors, {}) : undefined;
  return {
    generatedControls,
    error
  };
}
export default WorkbenchItemControls;